export default {
	STORE: '26214400', //25mb
}
